<template>
  <div @keyup.enter="changePassword">
    <DataBox :loading="tryGetSessions" :error="error">
      <UiCard class="settings_wrapper">
        <div slot="title">
          <div class="title">Активные cессии</div>
        </div>

        <!-- prettier-ignore -->
        <div slot="content">
          <div v-for="(session, i) in sessions" :key="i" class="item">
            <div class="data">
              <div class="item_line"> {{ session.city }} </div>
              <div class="item_line"> {{ session.sms_auth ? '[2FA]' : '[1FA]' }} ⋅ {{ session.ip }} ⋅ {{ session.device }}</div>
              <div class="item_line"> Дата создания: {{ format(session.created_at) }} </div>
              <div class="item_line"> Последняя активность: {{ format(session.last_used_at) }} </div>
            </div>

            <div class="action">
              <span v-if="session.is_current" class="online">Онлайн</span>
              <span v-else class="like-a" @click="deleteSession(session)">Завершить</span>
            </div>
          </div>
        </div>

        <div slot="footer">
          <UiButton :class="['button', 'is-blue']" @click="terminateSessions">
            Выйти на других устройствах
          </UiButton>
        </div>
      </UiCard>
    </DataBox>
  </div>
</template>

<script>
import UiCard from '@/components/card/UiCard.vue'
import UiButton from '@/components/UiButton.vue'
import DataBox from '@/components/DataBox.vue'

import { AuthService } from '@/services/auth.service'

import { fromDate } from '@/mixins/formatDateTime'

import { datetime } from '@/config'

export default {
  components: {
    UiCard,
    UiButton,
    DataBox,
  },
  data() {
    return {
      tryGetSessions: false,
      sessions: null,
      error: false,
    }
  },
  mounted() {
    this.getSessions()
  },
  methods: {
    /**
     * Send request for get active sessions list.
     */
    async getSessions() {
      this.tryGetSessions = true
      try {
        const { data } = await AuthService.getSessions()

        this.sessions = data.sessions

        this.setCurrentSessionFlag()
      } catch (error) {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
        this.error = error.message
      } finally {
        this.tryGetSessions = false
      }
    },

    /**
     * Terminate all session besides current session.
     */
    async terminateSessions() {
      try {
        const result = await this.$swal.fire({
          title: 'Подтверждение',
          text: 'Вы действительно хотите завершить все другие сеансы?',
          showCancelButton: true,
          confirmButtonText: 'Завершить',
          showLoaderOnConfirm: true,
          allowOutsideClick: !this.$swal.isLoading,
          preConfirm: () => {
            return AuthService.terminateSessions().catch((error) => {
              this.$store.commit('toast/NEW', { type: 'error', message: error.message })

              return false
            })
          },
        })

        if (result.isConfirmed) {
          this.$store.commit('toast/NEW', { type: 'success', message: 'Операция выполнена.' })

          this.getSessions()
        }
      } catch (error) {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
      }
    },

    /**
     * Terminate session by id.
     */
    async deleteSession(session) {
      try {
        const result = await this.$swal.fire({
          title: 'Подтверждение',
          text: 'Вы действительно хотите завершить данную сессию?',
          showCancelButton: true,
          confirmButtonText: 'Завершить',
          showLoaderOnConfirm: true,
          allowOutsideClick: !this.$swal.isLoading,
          preConfirm: () => {
            return AuthService.deleteSession(session).catch((error) => {
              this.$store.commit('toast/NEW', { type: 'error', message: error.message })

              return false
            })
          },
        })

        if (result.isConfirmed) {
          this.$store.commit('toast/NEW', { type: 'success', message: 'Операция выполнена.' })

          this.getSessions()
        }
      } catch (error) {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
      }
    },

    format(date) {
      return fromDate(date, datetime.FORMAT_DATETIME)
    },

    getCurrentTokenId() {
      const token = AuthService.getLocalStorageBearer().split('|')[0]

      return parseInt(token)
    },

    /**
     * It is necessary so that the interface does not display
     * the `session end` button for the current session.
     */
    setCurrentSessionFlag() {
      const currentTokenId = this.getCurrentTokenId()
      const currentSession = this.sessions.find((s) => s.id === currentTokenId)

      this.$set(currentSession, 'is_current', true)
    },
  },
}
</script>

<style lang="scss" scoped>
.item {
  padding: 0 0 rem(8px) 0;
  margin: 0 0 rem(8px) 0;
  border-bottom: 1px solid $color-gray-100;

  @include createFlex(flexbox, nowrap, row, flex-start, center, center);

  .data {
    @include flex-grow(1);
  }
  .action {
    @include flex-shrink(0);
    @include createFlex(flexbox, nowrap, column, flex-start, flex-end, flex-end);
  }

  &:last-child {
    border-bottom: none;
  }

  &_line {
    &:not(:last-child) {
      margin: 0 0 4px 0;
    }
  }

  .online {
    color: $green;
  }
}
</style>
